// src/context/persona/CreateIdentityStep.jsx
//
// The manual wizard's FIRST step (v198, moved out of NewPersonaPanel): the NAME and the MARKET — the two things
// that cannot be changed later. v201: the permanent identifier is never shown here — the editor derives it from
// the name and moves to the next free one when it is taken (`personaModel.uniquePersonaId`); what this step refuses
// is a NAME another persona already has (`taken`).
//
// Controlled and stateless: the editor owns name, market and id (it builds the draft and the PUT from them).
// The hints sit OUTSIDE their <label>: inside it they would become part of the input's accessible name.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { SEMANTIC } from '../../constants/theme.js';
import {
  alertBox, choiceHint, fieldLabel, fieldName, stepHeading, textInput,
} from './personaStyles.js';

// The markets offered at creation, in display order (`any` = fits B2B and B2C, a LIST market like `b2b`).
const MARKETS = ['b2b', 'any', 'b2c'];

export default function CreateIdentityStep({ name, market, taken, onName, onMarket, disabled }) {
  const { t } = useTranslation(['context']);
  return (
    <div>
      <h3 style={stepHeading}>{t('personas.wizard.identityHeading')}</h3>

      <label style={{ ...fieldLabel, marginBottom: '6px' }}>
        <span style={fieldName}>{t('personas.create.name')}</span>
        {/* v201: the same example as the AI create form; Italian, like the half this wizard writes. */}
        <input
          type="text" value={name} disabled={disabled} onChange={(e) => onName(e.target.value)} style={textInput}
          placeholder={t('personas.assist.createPlaceholders.name', { lng: 'it' })}
        />
      </label>
      {taken && <div style={{ ...alertBox(SEMANTIC.attenzione.fg), marginTop: '8px' }}>{t('personas.create.nameTaken')}</div>}

      <label style={{ ...fieldLabel, margin: '16px 0 6px' }}>
        <span style={fieldName}>{t('personas.fields.market')}</span>
        <select value={market} disabled={disabled} onChange={(e) => onMarket(e.target.value)} style={{ ...textInput, maxWidth: '260px' }}>
          {MARKETS.map((m) => <option key={m} value={m}>{t(`personas.markets.${m}`)}</option>)}
        </select>
      </label>
      <p style={{ ...choiceHint, marginTop: '6px' }}>{t('personas.fields.marketHint')}</p>
    </div>
  );
}
